<section aria-labelledby="locker-operations-title">
  <div class="section-heading">
    <div>
      <h2 id="locker-operations-title">Locker operations</h2>
    </div>
  </div>

  <div class="workbench">
    <form class="form-surface" #operationForm="ngForm" (ngSubmit)="submit()">
      <div class="form-grid">
        <div class="form-field full">
          <label for="operation-access-key">Lockedspace</label>
          <select id="operation-access-key" name="selectedId" class="form-select" [(ngModel)]="selectedId" (ngModelChange)="selectAccessKey()" required>
            <option value="" disabled>Select an access key</option>
            @for (item of accessKeyOptions(); track item.id) {
              <option [value]="item.id">{{ item.label }}</option>
            }
          </select>
        </div>
        <div class="form-field full">
          <label for="operation-type">Operation</label>
          <select id="operation-type" name="operation" class="form-select" [(ngModel)]="operation" required>
            <option value="" disabled>Select an operation</option>
            <option value="position">Position</option>
            <option value="ping">Ping</option>
            <option value="open">Open</option>
            <option value="lock">Lock</option>
          </select>
        </div>
        <div class="form-field">
          <label for="operation-provider">System provider</label>
          <input id="operation-provider" name="systemProvider" class="form-control" [(ngModel)]="systemProvider" readonly>
        </div>
        <div class="form-field">
          <label for="operation-user">Key user ID</label>
          <input id="operation-user" name="keyUserId" class="form-control" [(ngModel)]="keyUserId" readonly required>
        </div>
        <div class="form-field full">
          <label for="operation-access-id">Access ID</label>
          <input id="operation-access-id" name="accessId" class="form-control" [(ngModel)]="accessId" readonly required>
        </div>
        <div class="form-field full">
          <label for="operation-access-key-value">Access key</label>
          <input id="operation-access-key-value" name="accessKey" class="form-control code-input" [(ngModel)]="accessKey" readonly [required]="operation !== 'position'">
        </div>
        <div class="form-field">
          <label for="operation-latitude">Driver latitude</label>
          <input id="operation-latitude" name="latitude" type="number" step="any" class="form-control" [(ngModel)]="latitude" required>
        </div>
        <div class="form-field">
          <label for="operation-longitude">Driver longitude</label>
          <input id="operation-longitude" name="longitude" type="number" step="any" class="form-control" [(ngModel)]="longitude" required>
        </div>
      </div>
      <div class="form-actions">
        <button type="submit" class="btn btn-primary" [disabled]="operationForm.invalid">Run operation</button>
      </div>
    </form>

    <div>
      <app-api-endpoint [endpoint]="endpoint()" />

      <aside class="guidance-panel" aria-label="Locker operation instructions">
        <p>Choose a lockedspace to operate.</p>
        <p><strong>Description:</strong> Performs driver operations on the selected lockedspace.</p>
        <ul>
          <li><strong>Position</strong> - Returns the lockedspace longitude and latitude for display on a map.</li>
          <li><strong>Ping</strong> - Triggers horn or lights to help the driver locate the lockedspace.</li>
          <li><strong>Open</strong> - Sends an online command to open the lockedspace.</li>
          <li><strong>Lock</strong> - Sends an online command to lock the lockedspace.</li>
        </ul>
        <p><strong>Expected Result:</strong> The operation request is accepted successfully.</p>
      </aside>

      @if (positionResult(); as position) {
        <section class="position-result">
          <span>Lockedspace position</span>
          <strong>{{ position.latitude }}, {{ position.longitude }}</strong>
          <a class="btn btn-sm btn-outline-secondary" [href]="mapUrl(position)" target="_blank" rel="noopener noreferrer">Open map</a>
        </section>
      }
      <app-api-result
        [endpoint]="endpoint()"
        [showEndpoint]="false"
        [request]="call.request()"
        [response]="call.response()"
        [error]="call.error()"
      />
    </div>
  </div>
</section>